<template>
    <v-layout row wrap>
        <v-flex xs3 px-1>
        <v-card>
            <v-card-title class="pa-0 ma-0 py-1 subheading black--text text-xs-right" style="background:#F4F7FC;">
                <v-checkbox
                    class="pa-0 ma-0 col-2"
                    color="black"
                    single-line
                    v-model="selected"
                    label=""
                    @change="Checkall()"
                    hide-details
                    height="18px"
                    style="margin:0px;padding:0px;max-width:30px"
                    ></v-checkbox>
                    <span class="pa-0 ma-0 text-xs-left">Columns</span>
                   
            <v-spacer />
            <svg @click="refreshDataSet" width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <title>Refresh Data</title> 
                <g clip-path="url(#clip0)">
                <path d="M7.98185 24.2972C6.67688 23.1221 5.73548 21.7133 5.1187 20.2005C3.48261 16.1882 4.24872 11.4163 7.44298 8.12464L10.3905 11.0722C10.5528 11.2345 10.845 11.1176 10.884 10.8774L12.4941 0.340236C12.52 0.16494 12.3707 0.0156149 12.1954 0.0415845L1.65175 1.6517C1.41153 1.69066 1.29467 1.98282 1.45698 2.14513L4.41103 5.09917C-0.464776 10.0853 -1.2958 17.5646 1.90495 23.4078C2.86583 25.1672 4.19678 26.7773 5.8913 28.1278C8.77393 30.4196 12.3188 31.5168 15.8377 31.4454L16.4999 27.1149C13.4679 27.3746 10.3516 26.4397 7.98185 24.2972Z" fill="#BDBDBD"/>
                <path d="M27.5889 26.9007C32.4647 21.9145 33.2957 14.4353 30.0949 8.59209C29.1341 6.83265 27.8031 5.22253 26.1086 3.8721C23.226 1.58028 19.6811 0.483064 16.1622 0.554481L15.5 4.88492C18.5255 4.62522 21.6483 5.56013 24.018 7.70263C25.323 8.87776 26.2644 10.2866 26.8812 11.7993C28.5173 15.8117 27.7512 20.5836 24.5569 23.8752L21.6094 20.9277C21.447 20.7654 21.1549 20.8822 21.1159 21.1224L19.5058 31.6596C19.4798 31.8349 19.6292 31.9843 19.8045 31.9583L30.3481 30.3482C30.5884 30.3092 30.6987 30.0171 30.5429 29.8547L27.5889 26.9007Z" fill="#BDBDBD"/>
                </g>
                <defs>
                <clipPath id="clip0">
                <rect width="32" height="32" fill="white"/>
                </clipPath>
                </defs>
            </svg>
            <v-btn icon class="pa-0 ma-0">
            <svg
                width="20"
                height="20"
                viewBox="0 0 22 22"
                fill="none"
                @click="addColumn"
                xmlns="http://www.w3.org/2000/svg"
            >
                <title>Add Column</title>
                <circle cx="11" cy="11" r="11" stroke="#3D56E6" />
                <path
                d="M10.9998 7.69922V15.3992"
                stroke="#3D56E6"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
                <path
                d="M14.8506 11.55L7.15059 11.55"
                stroke="#3D56E6"
                stroke-linecap="round"
                stroke-linejoin="round"
                />
            </svg>
        </v-btn>
             <!-- <v-icon @click="refreshDataSet" small class="white--text pr-2">fas fa-sync</v-icon>
            <v-icon @click="addColumn" small class="white--text pr-3">fas fa-plus-circle</v-icon> -->
            </v-card-title>
            <hr />
            <v-card-text style="height:425px;overflow-y:auto" class="pa-0 ma-0">
            <v-flex xs12>
                <template v-for="(key,index) in value">
                    <v-layout row wrap class=" pa-0 ma-0">
                        <v-flex  xs9 >
                            <v-checkbox
                            v-model="key.visible"
                            :label="key.label"
                            color="blue"
                            single-line
                            class="pa-0 ma-0 filterCheck"
                            height="30px"
                            hide-details
                            @change="submit(key)"
                            style="margin:0px;padding:0px"
                            ></v-checkbox>
                        </v-flex>
                        <v-flex xs3  class="text-xs-right pt-1">
                             <svg
                                class="svgIcon2"
                                width="16"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                @click="setSelectedColumn(key)"
                            >
                                <title>Edit</title>
                                <path
                                d="M8.86676 2.9328H2.48878C2.00548 2.9328 1.54198 3.12479 1.20024 3.46653C0.858493 3.80828 0.666504 4.27178 0.666504 4.75508V17.511C0.666504 17.9943 0.858493 18.4578 1.20024 18.7996C1.54198 19.1413 2.00548 19.3333 2.48878 19.3333H15.2447C15.728 19.3333 16.1915 19.1413 16.5333 18.7996C16.875 18.4578 17.067 17.9943 17.067 17.511V11.1331"
                                stroke="#A3A3A3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                />
                                <path
                                d="M15.7003 1.56611C16.0627 1.20364 16.5544 1 17.067 1C17.5796 1 18.0712 1.20364 18.4337 1.56611C18.7962 1.92858 18.9998 2.4202 18.9998 2.93282C18.9998 3.44543 18.7962 3.93705 18.4337 4.29953L9.77786 12.9554L6.1333 13.8665L7.04444 10.2219L15.7003 1.56611Z"
                                stroke="#A3A3A3"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                />
                            </svg>
                        <!-- <v-icon @click="setSelectedColumn(key)" v-if="key.visible" small class="grey--text">fas fa-edit</v-icon> -->
                        &nbsp;
                        <svg width="15" @click="addFilter(key)" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <title>Filter</title>
                            <path d="M1.49772 1C0.973057 1 0.681579 1.62423 0.914761 2.06119L8.14343 12.4234V20.2887C8.14343 20.8506 8.66809 21.1627 9.13446 20.913L11.8161 19.4772C12.0492 19.3524 12.1658 19.1027 12.1658 18.853V12.4234L19.3945 2.06119C19.686 1.56181 19.3362 1 18.8115 1H1.49772Z" 
                                :stroke="reportFilters2[key.key] ?  'blue' : '#A3A3A3'" stroke-miterlimit="10"/>
                        </svg>
                        <!-- <v-icon small @click="addFilter(key)" :class="reportFilters2[key.key] ? 'blue--text' : 'grey--text' ">fas fa-filter</v-icon> -->
                        </v-flex>
                    </v-layout>
                    <v-divider class="blue lighten-3"/>
                </template>
            </v-flex>
            </v-card-text>
        </v-card>
        </v-flex>
        <v-flex xs9 v-if="!selectedColumn.label">
            <v-layout row wrap>
                <v-flex xs4 px-1>    
                    <v-card style="min-height:450px" >
                        <v-card-title  class="subheading black--text" style="background:#F4F7FC;">
                            <strong>Layout & Sort</strong>
                        </v-card-title>
                        <v-card-text style="height:425px;overflow-y:auto" v-if="!selectedColumn.label" >
                         <template v-for="layout in columnLayout">
                                <v-chip close @input="removeColumnFromLayout(layout)" small outline class="indigo--text">
                                    {{layout.label}}
                                </v-chip>
                            </template>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex xs4 px-1 >
                    <v-card >
                        <v-card-title class="subheading black--text" style="background:#F4F7FC;">
                            Filters
                        </v-card-title>
                        <v-card-text style="height:425px;overflow-y:auto" class="pa-0 ma-0">
                            <v-list  >
                                <v-list-tile
                                    color="indigo"
                                    v-for="(filter,index) in reportFilters2"
                                    :key="index"
                                    avatar
                                    @click=""
                                >
                                    <v-list-tile-content class="grey--text pa-0 ma-0">
                                        <v-list-tile-title class= "body-1">
                                            <v-icon small @click="deleteFilter(index)">fas fa-times</v-icon>
                                            &nbsp;
                                            &nbsp;
                                            {{ filter.label }} 
                                            &nbsp;  
                                            <v-icon small v-if="filter.type=='select'" class="pink--text">fas fa-angle-double-down</v-icon>

                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                         <svg
                                            class="svgIcon2"
                                            width="16"
                                            height="20"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                            @click="setSelectedFilter(filter)"
                                        >
                                            <title>Edit</title>
                                            <path
                                            d="M8.86676 2.9328H2.48878C2.00548 2.9328 1.54198 3.12479 1.20024 3.46653C0.858493 3.80828 0.666504 4.27178 0.666504 4.75508V17.511C0.666504 17.9943 0.858493 18.4578 1.20024 18.7996C1.54198 19.1413 2.00548 19.3333 2.48878 19.3333H15.2447C15.728 19.3333 16.1915 19.1413 16.5333 18.7996C16.875 18.4578 17.067 17.9943 17.067 17.511V11.1331"
                                            stroke="#A3A3A3"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            />
                                            <path
                                            d="M15.7003 1.56611C16.0627 1.20364 16.5544 1 17.067 1C17.5796 1 18.0712 1.20364 18.4337 1.56611C18.7962 1.92858 18.9998 2.4202 18.9998 2.93282C18.9998 3.44543 18.7962 3.93705 18.4337 4.29953L9.77786 12.9554L6.1333 13.8665L7.04444 10.2219L15.7003 1.56611Z"
                                            stroke="#A3A3A3"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            />
                                        </svg>
                                        <!-- <v-icon @click="setSelectedFilter(filter)" small >fas fa-edit</v-icon> -->
                                    </v-list-tile-action>
                                </v-list-tile>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex xs4 px-1>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-card style="min-height:225px" >
                                <v-card-title class="subheading black--text" style="background:#F4F7FC;">
                                    Sorting
                                </v-card-title>
                                <v-card-text style="height:200px;overflow-y:auto">
                                    <v-autocomplete
                                     :items="sortColumns"
                                        class="style-input mr-2"
                                        label="Columns"
                                        outline
                                        single-line
                                        height="15px"
                                        return-object
                                        item-text="name"
                                        item-value="id"
                                        @input="addSort"
                                        v-model="sortColumn"                                      
                                    />
                                    <v-list dense >
                                        <v-list-tile class="sortList"
                                            color="indigo"
                                            v-for="(sort,index) in selectedSort"
                                            :key="sort.id"
                                            avatar
                                        >
                                            <v-list-tile-content class="grey--text pa-0 ma-0">
                                                <v-list-tile-title class= "body-2 ">
                                                    <v-icon small @click="deleteSort(index)">fas fa-times</v-icon>
                                                    &nbsp;
                                                        {{ sort.name }}
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>
                                                <v-switch 
                                                    v-model="sort.sort"
                                                    :label="sort.sort" small style="zoom:90%"
                                                    true-value="Asc"
                                                    false-value="Desc"
                                                />
                                            </v-list-tile-action>
                                        <hr/>
                                        </v-list-tile>
                                        
                                    </v-list>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex xs12>
                            <v-card style="min-height:225px" >
                                <v-card-title class="subheading black--text" style="background:#F4F7FC;">
                                    Group By
                                </v-card-title>
                                <v-card-text style="height:200px;overflow-y:auto">
                                    <v-layout row  wrap>
                                        <v-flex xs12>
                                    <v-autocomplete
                                        :items="groupByColumns"
                                        class="style-input mr-2"
                                        label="Columns"
                                        outline
                                        single-line
                                        height="15px"
                                        return-object
                                        item-text="name"
                                        item-value="id"
                                        @input="addGroupBy"
                                        v-model="groupByColumn"
                                    />
                                        </v-flex>
                                        <v-flex xs12>
                                    <v-list dense >
                                        <v-list-tile class="sortList"
                                            color="indigo"
                                            v-for="(groupBy,index) in selectedGroupBy"
                                            :key="groupBy.id"
                                            avatar
                                        >
                                            <v-list-tile-content class="grey--text pa-0 ma-0">
                                                <v-list-tile-title class= "body-2 ">
                                                    <v-icon small @click="deleteGroupBy(index)">fas fa-times</v-icon>
                                                    &nbsp;
                                                        {{ groupBy.name }} 
                                                    <!-- <svg
                                                        class="svgIcon2"
                                                        width="16"
                                                        height="20"
                                                        viewBox="0 0 20 20"
                                                        fill="none"
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        @click="showGroupEdit(groupBy)"
                                                    >
                                                        <title>Edit</title>
                                                        <path
                                                        d="M8.86676 2.9328H2.48878C2.00548 2.9328 1.54198 3.12479 1.20024 3.46653C0.858493 3.80828 0.666504 4.27178 0.666504 4.75508V17.511C0.666504 17.9943 0.858493 18.4578 1.20024 18.7996C1.54198 19.1413 2.00548 19.3333 2.48878 19.3333H15.2447C15.728 19.3333 16.1915 19.1413 16.5333 18.7996C16.875 18.4578 17.067 17.9943 17.067 17.511V11.1331"
                                                        stroke="#A3A3A3"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        />
                                                        <path
                                                        d="M15.7003 1.56611C16.0627 1.20364 16.5544 1 17.067 1C17.5796 1 18.0712 1.20364 18.4337 1.56611C18.7962 1.92858 18.9998 2.4202 18.9998 2.93282C18.9998 3.44543 18.7962 3.93705 18.4337 4.29953L9.77786 12.9554L6.1333 13.8665L7.04444 10.2219L15.7003 1.56611Z"
                                                        stroke="#A3A3A3"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                        />
                                                    </svg> -->
                                                </v-list-tile-title>
                                            </v-list-tile-content>
                                            <v-list-tile-action>                                                
                                                <GroupIcon @clicked="showDialog(groupBy)" />
                                               <!--    <v-text-field outline v-model ="groupBy.subtotal" width="10px" />
                                              <v-switch 
                                                    v-model="sort.sort"
                                                    :label="sort.sort" small style="zoom:90%"
                                                    true-value="Asc"
                                                    false-value="Desc"
                                                /> -->
                                            </v-list-tile-action>
                                        <hr/>
                                        </v-list-tile>
                                        
                                    </v-list>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs9 pl-2  v-if="selectedColumn.label">
            <v-card>
                <v-card-title v-if="selectedColumn.label" class="subheading body-2 black--text" style="background:#F4F7FC;">
                    <strong>{{selectedColumn.label}} </strong>
                    <v-spacer />
                    <v-icon @click="saveNewColumn" small class="black--text">fas fa-save</v-icon>
                    <v-icon @click="clearSelected" small class="black--text">fas fa-times</v-icon>
                </v-card-title>
                <v-card-text v-if="selectedColumn.label" >
                    <v-layout row wrap>
                        <v-flex xs3 pr-2>
                            <b>Column Name</b><br/>
                        <v-text-field
                            class="style-input mr-2 pt-1"
                            outline
                            type="text"
                            @change="submit3"
                            v-model="selectedColumn.key"
                            required
                        />
                        </v-flex>
                        <v-flex xs3 pr-2>
                            <b>Label</b><br/>
                        <v-text-field
                            class="style-input mr-2 pt-1"
                            outline
                            type="text"
                            @change="submit3"
                            v-model="selectedColumn.label"
                            required
                        />
                        </v-flex>
                        <v-flex xs3 pr-2>
                            <b>Data Type</b><br/>
                        <v-select
                            class="style-input mr-2 pt-1"
                            outline
                            item-text="name"
                            item-value="id"
                            @change="submit3"
                            v-model="selectedColumn.dataType"
                            :items="dataTypes"
                        ></v-select>
                        </v-flex>
                        <v-flex xs3 pr-2>
                            <b>Format</b><br/>
                        <v-text-field
                            class="style-input mr-2 pt-1"
                            outline
                            type="text"
                            @change="submit3"
                            v-model="selectedColumn.format"
                            required
                        />
                        </v-flex>
                        <v-flex xs1 pr-2>
                            <b>Width</b><br/>
                            <v-text-field
                                class="style-input mr-2 pt-1"
                                outline
                                type="text"
                                @change="submit3"
                                v-model="selectedColumn.width"
                                required
                            />
                        </v-flex>
                        <v-flex xs1 pr-2>
                            <b>Height</b><br/>
                            <v-text-field
                                class="style-input mr-2 pt-1"
                                outline
                                type="text"
                                @change="submit3"
                                :readonly="selectedColumn.dataType=='image'"
                                v-model="selectedColumn.height"
                                required
                            />
                        </v-flex>
                        <v-flex xs2 pr-2>
                            <b>Font</b><br/>
                            <v-autocomplete
                                :items="fontList"
                                class="style-input mr-2 pt-1"
                                outline
                                hide-details
                                @change="submit3"
                                v-model="selectedColumn.font"
                            ></v-autocomplete>
                        </v-flex>
                        <v-flex xs1>
                            <b>Size</b><br/>
                            <v-autocomplete
                                :items="fontSize"
                                class="style-input mr-2 pt-1"
                                outline
                                hide-details
                                @change="submit3"
                                v-model="selectedColumn.fontSize"
                            />
                        </v-flex>                        
                        <v-flex xs1 class="pa-3 pl-0 pr-0  text-xs-center">
                            <verte
                            :rgbSliders="true"
                            @change="submit3"
                            model="hex"
                            v-model="selectedColumn.color"
                            picker="wheel"
                            ></verte>
                        </v-flex>
                        <v-flex xs4 class="pa-3">
                           <v-btn-toggle
                                @change="submit3"
                                v-model="selectedColumn.bold"
                                class="transparent white--text"
                            >
                                <v-btn icon @click="submit" small class="black--text" flat>
                                <v-icon>format_bold</v-icon>
                                </v-btn>
                            </v-btn-toggle>
                            <v-btn-toggle
                                @change="submit3"
                                v-model="selectedColumn.italic"
                                class="transparent white--text"
                            >
                                <v-btn icon @click="submit" small class="black--text" flat>
                                <v-icon>format_italic</v-icon>
                                </v-btn>
                            </v-btn-toggle>
                           <v-btn-toggle
                                @change="submit3"
                                v-model="selectedColumn.align"
                                class="transparent white--text"
                            >
                                <v-btn @click="submit3" value="left" flat class="black--text">
                                <v-icon>format_align_left</v-icon>
                                </v-btn>
                                <v-btn @click="submit3" value="center" flat class="blac--text">
                                <v-icon>format_align_center</v-icon>
                                </v-btn>
                                <v-btn @click="submit3" value="right" flat class="black--text">
                                <v-icon>format_align_right</v-icon>
                                </v-btn>
                            </v-btn-toggle>
                        </v-flex>
                        <v-flex xs11>
                             <b>Expression</b><br/>
                            <v-textarea
                                class="style-input mr-2 pt-1"
                                type="text"
                                @change="submit3"
                                v-model="selectedColumn.expression"
                                required
                                outline
                            />
                            </v-flex>
                            <v-flex xs1 pl-3>
                                 <svg
                                    class="svgIcon2 mt-3"
                                    width="16"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                    @click="showExpressionDialog"
                                >
                                    <title>Edit Expression</title>
                                    <path
                                    d="M8.86676 2.9328H2.48878C2.00548 2.9328 1.54198 3.12479 1.20024 3.46653C0.858493 3.80828 0.666504 4.27178 0.666504 4.75508V17.511C0.666504 17.9943 0.858493 18.4578 1.20024 18.7996C1.54198 19.1413 2.00548 19.3333 2.48878 19.3333H15.2447C15.728 19.3333 16.1915 19.1413 16.5333 18.7996C16.875 18.4578 17.067 17.9943 17.067 17.511V11.1331"
                                    stroke="#A3A3A3"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    />
                                    <path
                                    d="M15.7003 1.56611C16.0627 1.20364 16.5544 1 17.067 1C17.5796 1 18.0712 1.20364 18.4337 1.56611C18.7962 1.92858 18.9998 2.4202 18.9998 2.93282C18.9998 3.44543 18.7962 3.93705 18.4337 4.29953L9.77786 12.9554L6.1333 13.8665L7.04444 10.2219L15.7003 1.56611Z"
                                    stroke="#A3A3A3"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    />
                                </svg>
                            <!-- <v-icon @click="showExpressionDialog" small>fas fa-edit</v-icon> -->
                            </v-flex>
                            <v-flex xs12>
                                <b>Mask For Roles</b><br/>
                                <v-autocomplete
                                :items="roles"
                                class="style-input mr-2 pt-1"
                                outline
                                multiple
                                chips
                                small-chips
                                clearable
                                deletable-chips
                                item-text="name"
                                item-value="id"
                                hide-details
                                v-model="selectedColumn.maskRoles"
                            ></v-autocomplete>
                            </v-flex>
                    </v-layout>
                </v-card-text>
               
            </v-card>

            <v-dialog v-model="expressionDialog" max-width="850px">
                <ExpressionBuilder
                    v-if="expressionDialog"
                    :columns="value"
                    v-on:applyExpression="applyExpression"
                />
            </v-dialog>
        </v-flex>
           <v-dialog v-model="lookupDialog" max-width="850px">
               <SetLookup 
                :value="selectedFilter"
                v-on:closeDialog="closeDialog"
                />
            </v-dialog>
             <v-dialog v-model="groupDialog" max-width="550px">
                <GroupBy :setGroupTotal="setGroupTotal"  :selectedGroupColumn="selectedGroupColumn" v-on:selectedGroup="setSelectedGroup"
                    v-if="showGroupDialog" v-on:closeDialog="groupDialog=false; showGroupDialog=false;" />
            </v-dialog>
    </v-layout>
</template>
<script>
import Verte from "verte";
import SetLookup from './SetLookup.vue'
import "verte/dist/verte.css";
import ExpressionBuilder from "@/components/ExpressionBuilder.vue";
import GroupBy from './GroupBy.vue'
import GroupIcon from '@/components/Icons/IconGroup.vue'
import RoleModel from "@/api/service/RolesService.js"
import lodash from 'lodash'
export default {
    props:["value","reportFilters","reportLayout","reportSort", "reportGroup"],
    components: {
        Verte,
        ExpressionBuilder,
        SetLookup,
        GroupBy,
        GroupIcon
        },
    data() {
        return {
            columnLayout:{},
            selectedColumn:{},
            selectedFilter:{},
            dialog:false,
            selected:false,
            lookupDialog:false,
            sortColumn:{},
            groupByColumn:{},
            groupByColumns:[],
            roles:[],
            setGroupTotal:[],
            selectedGroupColumn:{},
            selectedGroupBy:{},
            reportFilters2:{},
            newColumn:false,
            expressionDialog: false,
            selectedSort:{},
            sortColumns:[],
            showGroupDialog:false,
            groupDialog:false,
            dataTypes: [
                { id: "date", name: "Date" },
                { id: "time", name: "Time" },
                { id: "number", name: "Decimal" },
                { id: "currency", name: "Currency" },
                { id: "image", name: "Image" },
                { id: "integer", name: "Number" },
                { id: "expression", name: "Expression" },
                { id: "varible", name: "Variable" },
                { id: "string", name: "Text" }
            ],
            fontList: [
                { text: "Arial" },
                { text: "Calibri" },
                { text: "Courier" },
                { text: "Verdana" }
            ],
            fontSize: [
                { text: "100%" },
                { text: "75%" },
                { text: "50%" },
                { text: "25%" },
                { text: "0%" }
            ],    
        }
    },
    watch: {
        
        value() {
           //   alert('i am here in the vlauef')
          
        this.getSortColumns()
            this.$forceUpdate()
        },
        columnLayout() {
            this.$emit('layoutChanged',this.selectedSort,this.columnLayout,this.reportFilters2, this.selectedGroupBy)
        },
        selectedSort() {
             this.$emit('layoutChanged',this.selectedSort,this.columnLayout,this.reportFilters2, this.selectedGroupBy)
        },
        reportFilters2() {
             this.$emit('layoutChanged',this.selectedSort,this.columnLayout,this.reportFilters2, this.selectedGroupBy)
        },
        reportFilters() {
            this.reportFilters2 = Object.assign({},this.reportFilters)
            this.$forceUpdate()
        },
        groupByColumn(){
            this.$emit('layoutChanged',this.selectedSort,this.columnLayout,this.reportFilters2, this.selectedGroupBy)
        },
        reportGroup(){
            this.groupByColumn = Object.assign({}, this.reportGroup)
            this.$forceUpdate()
        }
        /*reportLayout() {
            this.columnLayout = Object.assign({},this.reportLayout)
            this.$forceUpdate()
        },
        reportSort() {
            this.selectedSort = Object.assign({},this.reportSort)
            this.$forceUpdate()
        },*/
    },
    created: function() {
        this.reportFilters2 = Object.assign({},this.reportFilters)
        this.columnLayout = Object.assign({},this.reportLayout)
        this.selectedSort = Object.assign({},this.reportSort)
        this.selectedGroupBy = Object.assign({}, this.reportGroup)
        this.getSortColumns()
        this.getRoles()
        this.$forceUpdate()
        
    },
    methods: {
        async getRoles(){
            this.roles = await RoleModel.findAll({active:1})
        },
        getSortColumns() {
            let $parent = this 
            lodash.forEach(this.value,function($obj) {
                $parent.sortColumns.push({
                    "id":$obj.key,
                    "name":$obj.label
                })
                $parent.groupByColumns.push({
                    "id":$obj.key,
                    "name":$obj.label
                })
                if( $obj.dataType =='float' || $obj.dataType =='decimal' ){
                    $parent.setGroupTotal.push({
                        "id":$obj.key,
                        "name":$obj.label,
                        "dataType": $obj.dataType
                    })
                }
            })
        },
        Checkall() {
            let $parent = this
            this.value = lodash.forEach(this.value,function($obj) {
                $obj.visible = $parent.selected
                $parent.submit($obj)
            })
        },
        submit($column) {
            let $columns=Object.keys(this.columnLayout)
            if($columns.indexOf($column.key)>=0) {
                //this.columnLayout.splice(this.columnLayout.indexOf($column.key),1)
                delete this.columnLayout[$column.key]
            } else {
                this.columnLayout[$column.key]=$column
            }
            this.$forceUpdate()
        },
        setSelectedColumn($column) {
            this.selectedColumn= $column
        },
        addSort() {
            //loadash.findIndex(this.selectedSort,{"id":})
            
            if(!this.selectedSort[this.sortColumn.id]) {
                this.selectedSort[this.sortColumn.id]=this.sortColumn
                this.selectedSort[this.sortColumn.id].sort= 'Asc'
            }
        },
        showDialog($group){
            this.groupDialog =true
            this.showGroupDialog = true
            this.selectedGroupColumn = $group
            this.$forceUpdate()
        },
        setSelectedGroup($group){
            this.selectedGroupBy[$group.id] = Object.assign({}, $group)
        },
        addGroupBy() {
            if(!this.selectedGroupBy[this.groupByColumn.id]) {
                this.selectedGroupBy[this.groupByColumn.id]=this.groupByColumn
                this.selectedGroupBy[this.groupByColumn.id].subtotal= ''
            }
        },
        deleteGroupBy($index){
            delete this.selectedGroupBy[$index ]
            this.$forceUpdate()
        },
        clearSelected() {
            this.selectedColumn= {}
        },
        removeColumnFromLayout($column) {
             delete this.columnLayout[$column.key]
             this.value[$column.key].visible=false
           // this.columnLayout.splice(this.columnLayout.indexOf($column.key),1)
        },
        applyExpression($expr) {
            this.selectedColumn.expression = $expr;
            this.expressionDialog = false;
            this.submit();
        },
        addColumn() {
            this.newColumn = true;
            this.selectedColumn = {
                key: "",
                dataType: "",
                width: 0,
                height: 0,
                visible: "",
                sort_order: 0,
                type: "",
                label: "<NewColumn>",
                fontSize: "",
                bold: false,
                italic: true,
                align: "left"
            };
        },
        submit3() {

        },
        addFilter($column) {
            if(this.reportFilters2[$column.key]){
           delete this.reportFilters2[$column.key]
            } else{
                 this.reportFilters2[$column.key] = {
                "type":"text",
                "key":$column.key,
                "label":$column.label
            }
            }
           // alert('fitlers')
            //alert(JSON.stringify(this.reportFilters2,null,4))
            this.$forceUpdate()
        },
        deleteFilter($index) {
            delete this.reportFilters2[$index  ]
            this.$forceUpdate()
        },
        deleteSort($index){
            delete this.selectedSort[$index  ]
            this.$forceUpdate()
        },
         saveNewColumn() {
            //let $columns = this.reportColumns;
            this.value[this.selectedColumn.key] = Object.assign(
                {},
                this.selectedColumn
            );
            //this.reportColumns = $columns;
            this.newColumn = false;
            //this.submit();
            this.$forceUpdate()
        },
        closeDialog($filter) {
            this.lookupDialog=false
            this.expressionDialog=false
            this.dialog=false
            this.reportFilters2[$filter.key]=$filter
        },
        showExpressionDialog() {
            this.expressionDialog=true
            this.lookupDialog=false
        },
        refreshDataSet($i) {
            this.$emit('refreshDataSet',this.selectedSort,this.columnLayout,this.reportFilters2, this.selectedGroupBy)
        },
        setSelectedFilter($filter) {
            this.selectedFilter= $filter
            //this.expressionDialog=false
            this.lookupDialog=true
            //alert('here')
            this.expressionDialog=false
            //alert('filter')
           //this.$forceUpdate()
        }
    }
}
</script>
<style >
.v-list__tile--avatar {
    height: 24px;
    min-width: 26px;
}
.filterCheck.v-input--checkbox .v-label.theme--light{
    color:black !important;
}
 .v-list--dense .sortList .v-list__tile--avatar {
    height: 30px !important;
}
</style>